/* eslint-disable @stylistic/max-len */
import type {RefObject} from 'react';

/**
 * The `ForestIconProps` interface defines the properties for the ForestIcon component.
 */
interface ForestIconProps {
    /** CSS class to override default styling. */
    className?: string;
    /** Primary color of the icon. */
    color1?: string;
    /** Height of the icon. */
    height?: number | string;
    ref?: RefObject<SVGSVGElement>;
    /** Test ID for Cypress. */
    testId?: string;
    /** Width of the icon. */
    width?: number | string;
}

/**
 * Material Symbol "forest" — outlined, weight 300.
 * Trees icon for the Nature tour category.
 *
 * @param props           The component props.
 * @param props.className CSS class override.
 * @param props.color1    Primary icon color.
 * @param props.height    Icon height.
 * @param props.ref       SVG element ref.
 * @param props.testId    Test identifier.
 * @param props.width     Icon width.
 * @returns A React SVG element.
 */
export const ForestIcon = ({
    className = '',
    color1 = 'currentColor',
    height,
    ref,
    testId = 'ForestIcon',
    width
}: ForestIconProps) => (
    <svg
        ref={ref}
        className={className}
        data-cy={testId}
        fill={color1}
        height={height}
        viewBox="0 -960 960 960"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M300-100v-160H37.7L194-500h-75.54L360-845.38l120 172 120-172L841.54-500H766l156.3 240H660v160H540v-160H420v160H300Zm343.61-220h168.85L655.54-560H726L600-740l-82.92 118.31L601.54-500H526l117.61 180Zm-496.07 0h424.92L415.54-560H486L360-740 234-560h70.46L147.54-320Zm0 0h156.92H234h252-70.46 156.92-424.92Zm496.07 0H526h75.54-84.46H726h-70.46 156.92-168.85ZM540-260h120-120Zm142.92 0Z" />
    </svg>
);

ForestIcon.displayName = 'ForestIcon';